import Chip, { ChipSize, ChipVariant } from "@galaxy-io/dls/chips/Chip";
import Alert, { AlertVariant } from "@galaxy-io/dls/feedback/Alert";
import { type ReviewState, reviewStates } from "@gtm/contracts/core/review";
import {
  CheckCircleIcon,
  CircleIcon,
  CircleNotchIcon,
  ClockIcon,
  PauseCircleIcon,
  TimerIcon,
  XCircleIcon,
} from "@phosphor-icons/react";
import { Inline } from "@/components/workspace/people-styles";
import { reviewIcons } from "./review-status";
export function Status({ value, label }: { value: string | null | undefined; label?: string }) {
  const state = (value || "waiting").toLowerCase();
  const reviewState = state === "new" ? "unprocessed" : state;
  const reviewIcon = reviewStates.includes(reviewState as ReviewState)
    ? reviewIcons[reviewState as ReviewState]
    : undefined;
  const success = [
    "processed",
    "sent",
    "succeeded",
    "complete",
    "completed",
    "connected",
    "configured",
    "collecting",
    "done",
    "reviewed",
    "open",
    "active",
  ].includes(state);
  const error = ["failed", "error", "disconnected", "terminated", "timed_out"].includes(state);
  const pending = ["queued", "retrying", "partial", "pending", "stale", "unknown"].includes(state);
  const closed = state === "closed";
  const running = ["running", "syncing", "sending"].includes(state);
  return (
    <Inline>
      <Chip
        label={
          label ||
          (state === "unprocessed"
            ? "New"
            : state.charAt(0).toUpperCase() + state.slice(1).replaceAll("_", " "))
        }
        variant={
          success
            ? ChipVariant.SUCCESS
            : error
              ? ChipVariant.ERROR
              : pending
                ? ChipVariant.WARNING
                : ChipVariant.SECONDARY
        }
        size={ChipSize.MEDIUM}
        icon={
          reviewIcon ??
          (success || closed
            ? CheckCircleIcon
            : error
              ? XCircleIcon
              : state === "continued_as_new"
                ? TimerIcon
                : running
                  ? CircleNotchIcon
                  : pending
                    ? ClockIcon
                    : state === "paused"
                      ? PauseCircleIcon
                      : CircleIcon)
        }
      />
    </Inline>
  );
}
export function Feedback({ message, error = false }: { message: string; error?: boolean }) {
  return message ? (
    <Alert header={message} variant={error ? AlertVariant.ERROR : AlertVariant.SUCCESS} />
  ) : null;
}
